export const loginActions = {
    SEND_CREDENTIALS: "SEND_CREDENTIALS",
    INVALID_PIN_CODE: "INVALID_PIN_CODE",
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    EXPIRED_TOKEN: "EXPIRED_TOKEN",
    DO_SIGNOUT: "DO_SIGNOUT",
    AUTHENTICATE: "AUTHENTICATE",
    SET_CURRENT_USER: "SET_CURRENT_USER"
};
